import React, { memo } from "react";
import TagsTable from "components/Admin/Tables/TagsTable";
import Widget from "../Widget";

interface Props {}

const TagsWidget: React.FC<Props> = () => {
  return (
    <Widget title="Тагове">
      <TagsTable />
    </Widget>
  );
};

export default memo(TagsWidget);
